export const studentCardColumns = ['Name', 'Pickup Status'];
